import React from "react";
import { Typography, Divider } from "@mui/material";
import Loader from "../../../components/layout/Loader";

const InvoicePreview = ({ pdf, documentType }) => {
  return (
    <>
      <Typography variant="h5" gutterBottom>
        {documentType === "Estimate" ? "Estimate Preview" : "Invoice Preview"}
      </Typography>
      <Divider className="mb-3" />
      {pdf ? (
        <div className="position-relative" style={{ height: "700px" }}>
          <iframe
            src={`data:application/pdf;base64,${pdf}`}
            title="Invoice PDF"
            className="w-100 h-100 border rounded shadow-sm"
            style={{ border: "none" }}
          />
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center h-100">
          <Loader />
        </div>
      )}
    </>
  );
};

export default InvoicePreview;